import React, { useState, useEffect } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Hint from '~/Common-Objects/UI/Hint/Hint'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n';
import ExampleTemplate1 from '../themeSelector/exampleTemplate1';
import ExampleTemplate2 from '../themeSelector/exampleTemplate2';
import ExampleTemplate3 from '../themeSelector/exampleTemplate3';
import postHogFunctions from '~/Classes/posthog';

export default function Summary({ job, setJob = () => { }, save = () => { }, back = () => { }, next = () => { } }) {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const updateValue = (ev) => {
        let newJob = { ...job }
        if (ev.target.name == "url") {
            newJob.url = ev.target.value;
        }
        else {
            newJob.results.socialLinks[ev.target.name] = ev.target.value;
        }
        setJob(newJob);
    }

    let emailAddress = "";
    let facebook = "";
    let twitter = "";
    let linkedin = "";
    let instagram = "";
    if (job.results.socialLinks) {
        emailAddress = job.results.socialLinks.email
        facebook = job.results.socialLinks.facebook
        twitter = job.results.socialLinks.twitter
        linkedin = job.results.socialLinks.linkedin
        instagram = job.results.socialLinks.instagram
    }

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ maxWidth: '720px', width: '100%' }}>
                    <h5 className='mar-b10 text-center'>{i18n.t('templates:brandAnalyzer.summaryPage.headerText')}</h5>
                    <p className='mar-b25 text-center'>{i18n.t('templates:brandAnalyzer.summaryPage.subHeaderText')}</p>
                </div>
                <div style={{ maxWidth: '720px', width: '100%' }}>
                    <Paper className="mar-b0" >
                        <h4 className="mar-b25">{i18n.t('templates:brandAnalyzer.summaryPage.companyInformation')}</h4>
                        <TextInput style={{ marginBottom: '20px' }} onChange={updateValue} name="url" value={job.url} label={i18n.t('company:my.websiteAddress')} iconLeft={<Icons icon="globe" />} />
                        <TextInput style={{ marginBottom: '20px' }} onChange={updateValue} name="email" value={emailAddress} label={i18n.t('company:my.primaryEmailAddress')} iconLeft={<Icons icon="envelope" />} />
                        <TextInput style={{ marginBottom: '20px' }} onChange={updateValue} name="facebook" value={facebook} label={i18n.t('company:my.facebookAddress')} iconLeft={<Icons icon="facebook" />} />
                        <TextInput style={{ marginBottom: '20px' }} onChange={updateValue} name="twitter" value={twitter} label={i18n.t('company:my.twitterAddress')} iconLeft={<Icons icon="twitter" />} />
                        <TextInput style={{ marginBottom: '20px' }} onChange={updateValue} name="instagram" value={instagram} label={i18n.t('company:my.instagramAddress')} iconLeft={<Icons icon="instagram" />} />
                        <TextInput style={{ marginBottom: '25px' }} onChange={updateValue} name="linkedin" value={linkedin} label={i18n.t('company:my.linkedInAddress')} iconLeft={<Icons icon="linkedin" />} />
                        <Hint className="hide-xs" style={{ margin: 0 }} iconLeft={<Icons icon="questionCircle" color="#2B2F41" style={{ height: 16, width: 16 }} />}>
                            {i18n.t('templates:brandAnalyzer.summaryPage.detailsCanBeChangedFromCompanyProfile')}
                        </Hint>
                    </Paper>
                </div>
            </div>

            <div className="quickFlex" style={{ justifyContent: "space-between", alignItems: "center" }}>
                <Button postHogTag="brand-analyzer-back-to-theme-picker" onClick={() => back()}>{i18n.t('back')}</Button>
                <Button iconRight={<Icons icon="arrowRight" />} for="nextButton" className={'button-primary'} disabled={false} onClick={() => {
                    postHogFunctions.capture('brand_analyzer_finished')
                    next()
                }} postHogTag="brand-analyzer-save-and-finish">{i18n.t('save-finish')}</Button>
            </div>
        </>
    )
}